import {Button, DialogActions, DialogContent} from '@material-ui/core';
import ClaimRouteConstants from 'Agent/Claims/ClaimRouteConstants';
import React from 'react';
import {useHistory} from 'react-router';
import Modal from 'Shared/components/Modal';

type ClaimsConfirmationModalProps = {
  onClose: () => void;
  policyNumber: string;
};

const ClaimsConfirmationModal = (props: ClaimsConfirmationModalProps) => {
  const history = useHistory();

  return (
    <Modal title="View Claims" open onClose={props.onClose}>
      <div className="card__dialog">
        <DialogContent>
          By clicking <strong>"I Agree"</strong>, I represent and warrant that I have read, understand and agree to
          abide by the terms of the Business Associate Addendum. I am accessing this claim information in my capacity as
          a Business Associate, and I will view only the minimum amount of Protected Health Information reasonably
          necessary to perform my duties.
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              history.push(ClaimRouteConstants.CLAIMS(props.policyNumber));
              props.onClose();
            }}
            color="primary"
          >
            I Agree
          </Button>
          <Button onClick={props.onClose}>Cancel</Button>
        </DialogActions>
      </div>
    </Modal>
  );
};

export default ClaimsConfirmationModal;
